import { render, staticRenderFns } from "./IndexFooter.vue?vue&type=template&id=3f455cb5&scoped=true"
import script from "./IndexFooter.vue?vue&type=script&lang=js"
export * from "./IndexFooter.vue?vue&type=script&lang=js"
import style0 from "./IndexFooter.vue?vue&type=style&index=0&id=3f455cb5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f455cb5",
  null
  
)

export default component.exports